const config = {
  "baseURL-2": "https://appw.hassanjameelapp.com/Visualbase/api/",
  "baseURL": "https://appw.hassanjameelapp.com/Visualbase/api/",
  "HjBaseURL": "https://appw.hassanjameelapp.com/api/Administration/",
  "cryptoKey": "852C68333E1FA",
  "controllURL": "https://appw.hassanjameelapp.com/",
  "mainURL": "https://appw.hassanjameelapp.com",
  "paymentURL": "https://appw.hassanjameelapp.com",
  "FilePathURL": "https://imagesfiles.hassanjameelapp.com/",
  "googleClientID": "485526966298-ojqe10eedtnrsmggf6j2apvh1mpqld7b.apps.googleusercontent.com",
  "facebookClientID": "1028472824382935"
}
export function setConfig(cfg) {
  Object.assign(config, cfg); // ندمج القيم داخل نفس الكائن
}

export default config;
